import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import i18n from './locales'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(i18n)
app.use(router)
app.use(ElementPlus)
app.mount('#app')

import './assets/static/css/d7ce2f10-index-D8TvQkwm.css'